var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"confirm-special-button inline-block",class:{ triggered: _vm.triggered },on:{"touchstart":_vm.onTouchStart,"touchend":_vm.onTouchEnd,"mousedown":_vm.onMouseDown,"click":_vm.onClick}},[_c('img',{staticClass:"select-none pointer-events-none",attrs:{"src":require("@/assets/icons/genicon-confirm-special.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }